import MainLayout from "../../Layouts/Main/main";
import { CreateModule } from "../factory";
import navigation from "./navigations";

const Dashboard = ({ baseUrl }) =>
  CreateModule({ baseUrl, navigation, layout: MainLayout });
export default Dashboard;
